import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const SmsOptIn = lazy(() => import("@/pages/SmsOptIn"));

export const Route = createFileRoute("/sms-opt-in")({
  component: SmsOptIn,
});
